<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="section-1">
<h1><img alt="" src="media/file1.jpg" style="width:3.5625in;height:2.4375in"/></h1>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch007.vue?5ecb32e9